export default __webpack_public_path__ + "static/michael-0e8f5cbc534550e980ab7619a1aed9fe.jpg";